import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import sidebarData from "./SidebarData";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Poke_party from "../../functions/Poke_party";
import { useRecoilValue } from "recoil";
import {
  unreadNotificationsCountState,
  unreadMessages,
  unreadTrades,
  partyState,
} from "../../Recoil/atom";
import "../../assets/scss/roster.css";

const PicImage = ({ member }) => {
  const imgSrc = `/icon/${member.name}.png`;
  return (
    <Link className="link-image">
      <i>
        <img alt={member.name} src={imgSrc} />
      </i>
    </Link>
  );
};

const Sidebar = (props) => {
  const party = Poke_party();
  const ref = useRef();
  const isCollapsed = props.type === "condensed"; // Determine if the sidebar is collapsed
  const unreadCountValue = useRecoilValue(unreadNotificationsCountState);
  const partyValue = useRecoilValue(partyState);
  const unreadMessageCount = useRecoilValue(unreadMessages);
  const unreadTradesCount = useRecoilValue(unreadTrades);
  const [unreadCount, setUnreadCount] = useState(unreadCountValue);
  const [unreadMess, setUnreadMessageCount] = useState(unreadMessageCount);
  const [unreadTrade, setUnreadTrade] = useState(unreadTradesCount);

  // Update unreadCount whenever unreadNotificationsCountState changes
  useEffect(() => {
    setUnreadCount(unreadCountValue);
  }, [unreadCountValue]);

  useEffect(() => {
    setUnreadMessageCount(unreadMessageCount);
  }, [unreadMessageCount]);

  useEffect(() => {
    setUnreadTrade(unreadTradesCount);
  }, [unreadTradesCount]);

  // Update sidebar data for Notifications and Messages
  const updatedSidebarData = sidebarData.map((item) => {
    if (item.label === "Notifications") {
      return { ...item, badgeValue: unreadCount.toString() };
    }
    if (item.label === "Messages") {
      return { ...item, badgeValue: unreadMess.toString() };
    }
    if (item.label === "Manage Trades") {
      return { ...item, badgeValue: unreadTrade.toString() };
    }
    return item;
  });

  // Toggle function to toggle sidebar classes on click
  const tToggle = () => {
    const body = document.body;

    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");

      // **Fix: Collapse any expanded menu items when sidebar is collapsed**
      if (body.classList.contains("vertical-collpsed")) {
        document
          .querySelectorAll("#side-menu-item .mm-active")
          .forEach((item) => {
            item.classList.remove("mm-active"); // Remove active classes from expanded menus
          });

        document.querySelectorAll("#side-menu-item ul").forEach((subMenu) => {
          subMenu.style.display = "none"; // Hide any visible submenus
        });
      }
    }
  };

  const handleMenuClick = (hasSubItems = false) => {
    if (window.innerWidth <= 998 && !hasSubItems) {
      document.body.classList.remove("sidebar-enable");
    }
  };

  useEffect(() => {
    new MetisMenu("#side-menu-item");
  }, []);

  return (
    <React.Fragment>
      <div className={`vertical-menu ${isCollapsed ? "collapsed" : ""}`}>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              <li className="menu-title">{props.t("Roster")}</li>
              <div className="link-images">
                {isCollapsed ? (
                  <PicImage key={0} member={party[0]} />
                ) : (
                  partyValue.map((member, index) => (
                    <PicImage key={index} member={member} />
                  ))
                )}
              </div>
              {updatedSidebarData.map((item, key) => (
                <React.Fragment key={key}>
                  {item.isMainMenu ? (
                    <li className="menu-title">{props.t(item.label)}</li>
                  ) : (
                    <li>
                      <Link
                        to={item.url ? item.url : "/#"}
                        className={
                          item.issubMenubadge || item.isHasArrow
                            ? " "
                            : "has-arrow"
                        }
                        onClick={() => handleMenuClick(!!item.subItem)}
                      >
                        {item.icon && (
                          <i
                            className={item.icon}
                            style={{ marginRight: "5px" }}
                          ></i>
                        )}
                        {item.issubMenubadge && (
                          <span
                            className={`badge rounded-pill float-end bg-danger`}
                          >
                            {item.badgeValue || "0"}{" "}
                            {/* Show "0" if no value */}
                          </span>
                        )}
                        <span>{props.t(item.label)}</span>
                      </Link>
                      {item.subItem && (
                        <ul className="sub-menu">
                          {item.subItem.map((subItem, subKey) => (
                            <li key={subKey}>
                              <Link
                                to={subItem.link}
                                onClick={() => handleMenuClick(!!subItem.subMenu)}
                                className={
                                  subItem.subMenu && "has-arrow waves-effect"
                                }
                              >
                                {props.t(subItem.sublabel)}
                              </Link>
                              {subItem.subMenu && (
                                <ul className="sub-menu">
                                  {subItem.subMenu.map((menuItem, menuKey) => (
                                    <li key={menuKey}>
                                      <Link to="#">
                                        {props.t(menuItem.title)}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(Sidebar));
